export default "__VITE_ASSET__CtPgXXEC__"